import { render, staticRenderFns } from "./pendingShop.vue?vue&type=template&id=733115fe&scoped=true"
import script from "./pendingShop.vue?vue&type=script&lang=js"
export * from "./pendingShop.vue?vue&type=script&lang=js"
import style0 from "./pendingShop.vue?vue&type=style&index=0&id=733115fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733115fe",
  null
  
)

export default component.exports